import { render, staticRenderFns } from "./InvoiceTracker.vue?vue&type=template&id=4498a991"
import script from "./InvoiceTracker.vue?vue&type=script&lang=js"
export * from "./InvoiceTracker.vue?vue&type=script&lang=js"
import style0 from "./InvoiceTracker.vue?vue&type=style&index=0&id=4498a991&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports